import React from 'react';
import styled from 'styled-components';

import PlayupLogo from './assets/logo_inverted.png';
import DraftstarsLogo from './assets/logo-draftstars_inverted.png';
import SRMIcon from './SRMIcon';
import PayIdLogo from './assets/PayId-logo.png';
import RapidfireLogo from './assets/Rapidfire-logo.png';
import UploadIcon from './assets/upload-icon.png';

const RapidFireImg = styled.img({
	backgroundColor: '#fff',
	height: 'calc(calc(80vh * .9) * .1)',
	objectFit: 'contain',
});

export const SlidesConfig = {
	'1.0.0': [
		{
			image: require('./assets/slide1.png').default,
			imageMobile: require('./assets/slide1-app.png').default,
			title: 'Together at last!',
			content: (
				<>
					Double your gaming experience <br /> in one simple app.
				</>
			),
			footer: (
				<div className="brands">
					<img src={PlayupLogo} alt="Playup Logo" />
					<span>+</span>
					<img src={DraftstarsLogo} alt="Draftstars Logo" />
				</div>
			),
		},
		{
			image: require('./assets/slide2.png').default,
			imageMobile: require('./assets/slide2-app.png').default,
			title: 'Easily Switch Between Products',
			content: (
				<>
					Tap to toggle between PlayUp and Draftstars <br /> whether you want to bet or play fantasy.
				</>
			),
			footer: (
				<div className="brands">
					<img src={PlayupLogo} alt="Playup Logo" />
					<span>+</span>
					<img src={DraftstarsLogo} alt="Draftstars Logo" />
				</div>
			),
		},
		{
			image: require('./assets/slide3.png').default,
			imageMobile: require('./assets/slide3-app.png').default,
			title: 'Single Account',
			content: (
				<>
					Any current balance will be available to <br /> use across both betting and fantasy.
				</>
			),
			footer: (
				<div className="brands">
					<img src={PlayupLogo} alt="Playup Logo" />
					<span>+</span>
					<img src={DraftstarsLogo} alt="Draftstars Logo" />
				</div>
			),
		},
		{
			image: require('./assets/slide4.png').default,
			imageMobile: require('./assets/slide4-app.png').default,
			title: 'Simple Transaction History',
			content: (
				<>
					All bets placed or fantasy contests entered will be <br /> viewable in your account along with the results.
				</>
			),
			footer: (
				<div className="brands">
					<img src={PlayupLogo} alt="Playup Logo" />
					<span>+</span>
					<img src={DraftstarsLogo} alt="Draftstars Logo" />
				</div>
			),
		},
	],
	'1.27.0': [
		{
			image: require('./assets/SRM-Desktop.png').default,
			imageMobile: require('./assets/SRM.png').default,
			title: 'Same Race Multi',
			content: (
				<>
					Combine multiple runners in the <br /> same bet for greater odds.
				</>
			),
			footer: (
				<div className=" _flex _items-center _justify-center  _py-6">
					<SRMIcon width={63} height={24} />
				</div>
			),
		},
		{
			image: require('./assets/InstantWithdrawals-Desktop.png').default,
			imageMobile: require('./assets/InstantWithdrawals.png').default,
			title: 'Instant Withdrawals',
			content: <>Withdraw faster than ever.</>,
			footer: (
				<div className=" _flex _items-center _justify-center   _py-6">
					<img width={40} src={UploadIcon} alt="PayId Logo" />
				</div>
			),
		},
		{
			image: require('./assets/Rapidfire-Desktop.png').default,
			imageMobile: require('./assets/RapidFire.png').default,
			title: 'RapidFire',
			content: (
				<div>
					The easiest way to play daily fantasy sports.
					<br /> Pick who you think will score more Draftstars points for each of <br /> the five chosen head-to-head
					match-ups. Track with live statistics.
				</div>
			),
			footer: (
				<div className=" _flex _items-center _justify-center _bg-white">
					<RapidFireImg
						style={{
							backgroundColor: '#fff',
						}}
						className={'  _w-56 _bg-white'}
						src={RapidfireLogo}
						alt="PayId Logo"
					/>
				</div>
			),
		},
		{
			image: require('./assets/PayID-Desktop.png').default,
			imageMobile: require('./assets/PayID.png').default,
			title: 'PayID',
			content: <>Another way to add funds to your account.</>,
			footer: (
				<div className=" _flex _items-center _justify-center _py-6">
					<img
						style={{
							backgroundColor: '#fff',
						}}
						className={' _w-24'}
						src={PayIdLogo}
						alt="PayId Logo"
					/>
				</div>
			),
		},
	],
};
